var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlowBusinessReasons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H76C78.2091 0 80 1.79086 80 4V76C80 78.2091 78.2091 80 76 80H4C1.79086 80 0 78.2091 0 76V4Z",
    fill: "#5F11EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5486_1678",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5486_1678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4513 45.5971C42.3263 45.5971 43.9165 44.9992 45.2221 43.8033C46.5276 42.6075 47.1804 41.1592 47.1804 39.4583C47.1804 37.9675 46.7006 36.6967 45.7408 35.6458C44.7811 34.595 43.6175 34.0696 42.25 34.0696C41.0369 34.0696 40.0022 34.4631 39.1458 35.25C38.2894 36.037 37.8613 36.9963 37.8613 38.1279C37.8613 38.6168 37.9561 39.0926 38.1458 39.5554C38.3356 40.0185 38.6157 40.449 38.9863 40.8471L41 38.8888C40.8797 38.8054 40.7894 38.7013 40.7292 38.5763C40.6689 38.4513 40.6388 38.3147 40.6388 38.1667C40.6388 37.8056 40.7824 37.5024 41.0696 37.2571C41.3565 37.0115 41.75 36.8888 42.25 36.8888C42.8611 36.8888 43.3796 37.1365 43.8054 37.6321C44.2315 38.1274 44.4446 38.75 44.4446 39.5C44.4446 40.4386 44.0672 41.2335 43.3125 41.8846C42.5578 42.5357 41.6203 42.8613 40.5 42.8613C39.1167 42.8613 37.9468 42.3103 36.9904 41.2083C36.0337 40.1064 35.5554 38.7492 35.5554 37.1367C35.5554 36.2864 35.7129 35.4793 36.0279 34.7154C36.3426 33.9515 36.7963 33.2732 37.3888 32.6804L35.4029 30.6946C34.551 31.5185 33.8935 32.484 33.4304 33.5913C32.9676 34.6982 32.7363 35.8593 32.7363 37.0746C32.7363 39.4507 33.4863 41.4652 34.9863 43.1179C36.4865 44.7707 38.3082 45.5971 40.4513 45.5971ZM30 56.6667V49.5C28.4167 48.0556 27.1875 46.3681 26.3125 44.4375C25.4375 42.507 25 40.4722 25 38.3333C25 34.1667 26.4583 30.625 29.375 27.7083C32.2917 24.7917 35.8333 23.3333 40 23.3333C43.4722 23.3333 46.5486 24.3542 49.2292 26.3958C51.9097 28.4375 53.6528 31.0972 54.4583 34.375L56.7083 43.2779C56.8286 43.7129 56.7499 44.1088 56.4721 44.4654C56.1943 44.8218 55.824 45 55.3612 45H51.6667V50.5554C51.6667 51.3193 51.3947 51.9733 50.8508 52.5175C50.3067 53.0614 49.6526 53.3333 48.8888 53.3333H45V56.6667H42.2221V50.5554H48.8888V42.2221H53.5554L51.7779 35.0696C51.1204 32.4307 49.6944 30.2779 47.5 28.6113C45.3056 26.9446 42.8056 26.1113 40 26.1113C36.6111 26.1113 33.7268 27.2871 31.3471 29.6388C28.9676 31.9907 27.7779 34.8568 27.7779 38.2371C27.7779 39.9857 28.135 41.6468 28.8492 43.2204C29.5636 44.794 30.5768 46.1928 31.8887 47.4167L32.7779 48.25V56.6667H30Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowBusinessReasons);
export default __webpack_public_path__ + "static/media/icon-flow-business-reasons.669bf7ae2931ad3d3761d9145015beae.svg";
export { ForwardRef as ReactComponent };